import { createElement } from 'react';
import { RouteObject, redirect } from 'react-router-dom';

import { accountCreatePageRoute } from 'pages/AccountCreatePage';
import { accountUpdatePageRoute } from 'pages/AccountUpdatePage';

import { DEFAULT_SORT_ORDER, getDefaultAccountStatus, PAGE_SIZE } from 'widgets/AccountList';

import { isHasAccess, pathPermissions, replacePermissions } from 'features/validateAccess';

import { accountsService } from 'entities/account';

import { pathKeys } from 'shared/lib/react-router';

import AccountsPage from './AccountsPage';

export const accountsPageRoute: RouteObject = {
  path: pathKeys.account.root(),
  children: [
    {
      index: true,
      element: createElement(AccountsPage),
      loader: async (args) => {
        const requiredPermissions = replacePermissions(pathPermissions.account.root, args.params);
        if (!isHasAccess(requiredPermissions)) {
          return redirect(pathKeys.dashboard());
        }

        Promise.resolve(
          accountsService.prefetchQuery({
            page: 0,
            filter: getDefaultAccountStatus(),
            size: PAGE_SIZE,
            sort: DEFAULT_SORT_ORDER,
          }),
        );

        return args;
      },
    },
    accountUpdatePageRoute,
    accountCreatePageRoute,
  ],
};
